import classnames from 'classnames';
import React from 'react';
import onClickOutside from 'react-onclickoutside';

import handleItems from './utilities';

// targets with this classes own the menu
// dismiss clicks coming from these elements
const MENU_TRIGGER_CLASSES = ['navigationBar__avatar', 'navigationBar__more'];

class Menu extends React.Component {
  handleClickOutside(e) {
    if (!this.props.open || MENU_TRIGGER_CLASSES.includes(e.target.className)) {
      return;
    }

    this.props.onClose();
  }

  render() {
    const { className, open, items, stateProps } = this.props;
    const classNames = classnames('navigationBar__menu', className, { open });

    return (
      <ul className={classNames}>{handleItems(items, stateProps, null)}</ul>
    );
  }
}

export default onClickOutside(Menu);
